let activeFeedItem = null;
const initializedSliders = new Set();
let lastSwipeTime = 0;
let listenersInitialized = false;
let globalHasDragged = false;

function initFeedSlider(id) {
    const element = document.getElementById(id);
    if (!element) return;

    const slidesContainer = element.querySelector('.glide__slides');
    if (!slidesContainer) return;

    const allSlides = Array.from(slidesContainer.children);
    if (allSlides.length <= 1) return;

    // Calculate original slide count (half of total since Twig duplicates them)
    const originalSlideCount = allSlides.length / 2;

    let position = 0;
    let isHovering = false;
    let isDragging = false;
    let dragStartX = 0;
    let dragStartPosition = 0;
    let hasDragStarted = false;
    let hasDragged = false;
    const scrollSpeed = 0.4;
    const gap = 16;
    const dragThreshold = 5; // Minimum pixels to be considered a drag

    function getSlideWidth() {
        return allSlides[0] ? allSlides[0].offsetWidth : 0;
    }

    function animate() {
        if (!isDragging) {
            const speed = isHovering ? scrollSpeed * 0.25 : scrollSpeed;
            position -= speed;

            // Loop seamlessly when we've scrolled one full set
            const slideWidth = getSlideWidth();
            const loopDistance = originalSlideCount * (slideWidth + gap);

            if (loopDistance > 0 && Math.abs(position) >= loopDistance) {
                position += loopDistance;
            }
        }

        slidesContainer.style.transform = `translate3d(${position}px, 0, 0)`;
        requestAnimationFrame(animate);
    }

    // Mouse/touch drag handling
    function onDragStart(e) {
        hasDragStarted = true;
        hasDragged = false;
        isDragging = true;
        dragStartX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
        dragStartPosition = position;

        // Only preventDefault for mouse, not touch (to allow click events)
        if (e.type.includes('mouse')) {
            e.preventDefault();
        }
    }

    function onDragMove(e) {
        if (!hasDragStarted) return;

        const currentX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
        const diff = currentX - dragStartX;

        // Mark as dragged if moved beyond threshold
        if (Math.abs(diff) > dragThreshold) {
            hasDragged = true;
            globalHasDragged = true;
            lastSwipeTime = Date.now();

            // Now prevent default since it's an actual drag
            e.preventDefault();
        }

        position = dragStartPosition + diff;

        // Also check for loop during drag
        const slideWidth = getSlideWidth();
        const loopDistance = originalSlideCount * (slideWidth + gap);

        if (loopDistance > 0) {
            if (Math.abs(position) >= loopDistance) {
                position += loopDistance;
                dragStartPosition = position - diff;
            }
            // Also handle dragging to the right (positive direction)
            if (position > 0) {
                position -= loopDistance;
                dragStartPosition = position - diff;
            }
        }

        resetActiveFeedItem();
    }

    function onDragEnd(e) {
        hasDragStarted = false;
        isDragging = false;

        // Reset drag flag after a short delay
        setTimeout(() => {
            globalHasDragged = false;
        }, 100);
    }

    // Mouse events
    element.addEventListener('mousedown', onDragStart);
    document.addEventListener('mousemove', onDragMove);
    document.addEventListener('mouseup', onDragEnd);

    // Touch events
    element.addEventListener('touchstart', onDragStart, { passive: false });
    document.addEventListener('touchmove', onDragMove, { passive: false });
    document.addEventListener('touchend', onDragEnd);

    // Hover events
    element.addEventListener('mouseenter', () => {
        isHovering = true;
    });

    element.addEventListener('mouseleave', () => {
        isHovering = false;
    });

    // Set initial transform
    slidesContainer.style.transform = `translate3d(0px, 0, 0)`;

    // Start animation after a short delay to ensure slides have width
    setTimeout(() => {
        animate();
    }, 100);
}

function resetActiveFeedItem() {
    const activeItems = document.querySelectorAll('.feed-preview .feed-item.touch-active');
    activeItems.forEach(item => item.classList.remove('touch-active'));
    activeFeedItem = null;
}

function initFeedPreviewListeners() {
    if (listenersInitialized) return;
    listenersInitialized = true;

    document.addEventListener('mouseover', function(e) {
        const img = e.target.closest('.feed-preview .feed-item figure img.primary');
        if (img) {
            const hoverEl = img.parentElement.querySelector('.hover');
            if (hoverEl) {
                img.classList.add('hide');
                hoverEl.classList.add('show');
            }
        }
    });

    document.addEventListener('mouseout', function(e) {
        const img = e.target.closest('.feed-preview .feed-item figure img.primary');
        if (img) {
            const hoverEl = img.parentElement.querySelector('.hover');
            if (hoverEl) {
                img.classList.remove('hide');
                hoverEl.classList.remove('show');
            }
        }
    });

    document.addEventListener('click', function(e) {
        const feedItem = e.target.closest('.feed-preview .feed-item');
        if (!feedItem) return;

        const slider = feedItem.closest('.feed-preview-glide-lazy');

        // Prevent click if user just dragged
        if (slider && (globalHasDragged || Date.now() - lastSwipeTime < 300)) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }

        if ('ontouchstart' in window) {
            const link = feedItem.querySelector('a');

            // Second tap - execute action
            if (feedItem.classList.contains('touch-active')) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                resetActiveFeedItem();

                // Only execute action if there's a link
                if (link) {
                    const vimeoId = link.getAttribute('data-modal-vimeo-id');
                    if (vimeoId) {
                        openVimeoModal(vimeoId);
                    } else {
                        window.location.href = link.href;
                    }
                }
                return;
            }

            // First tap - show hover state
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            resetActiveFeedItem();
            activeFeedItem = feedItem;
            feedItem.classList.add('touch-active');
        } else {
            const modalLink = e.target.closest('[data-modal-vimeo-id]');
            if (modalLink) {
                e.preventDefault();
                const vimeoId = modalLink.getAttribute('data-modal-vimeo-id');
                if (vimeoId) {
                    openVimeoModal(vimeoId);
                }
            }
        }
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFeedPreviewListeners);
} else {
    initFeedPreviewListeners();
}

function setupIntersectionObserver() {
    if ('IntersectionObserver' in window) {
        const options = {
            root: null,
            rootMargin: '0px 0px 400px',
            threshold: 0
        };

        const onIntersectionChange = function (changes) {
            changes.forEach(change => {
                if (change.intersectionRatio > 0) {
                    const element = change.target;
                    const id = element.getAttribute('id');

                    if (id && !initializedSliders.has(id)) {
                        initializedSliders.add(id);
                        initFeedSlider(id);
                    }
                }
            });
        };

        const observer = new IntersectionObserver(onIntersectionChange, options);

        function setup() {
            const sliders = document.querySelectorAll('.feed-preview-glide-lazy');
            sliders.forEach(element => {
                if (!initializedSliders.has(element.id)) {
                    observer.observe(element);
                }
            });
        }

        setup();
        setTimeout(setup, 1000);
        setTimeout(setup, 3000);
    }
}

// Initialize intersection observer on page load
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupIntersectionObserver);
} else {
    setupIntersectionObserver();
}

function openVimeoModal(vimeoId) {
    const modal = document.createElement('div');
    modal.className = 'vimeo-lightbox';
    modal.innerHTML = `
        <div class="vimeo-lightbox-content">
            <div class="lazy-video-wrapper">
                <video autoplay playsinline class="lazy fade" data-vimeo-id="${vimeoId}" data-is-modal="true"></video>
                <div class="loader"></div>
            </div>
        </div>
        <div class="custom-cursor">Close</div>
    `;

    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';

    requestAnimationFrame(() => {
        modal.classList.add('show');
    });

    const video = modal.querySelector('video.lazy');
    loadVimeoVideo(video);

    const cursor = modal.querySelector('.custom-cursor');

    const updateCursor = function(e) {
        cursor.style.left = e.clientX + 'px';
        cursor.style.top = e.clientY + 'px';
    };

    modal.addEventListener('mousemove', updateCursor);

    modal.addEventListener('click', function(e) {
        if (e.target === modal || e.target.classList.contains('vimeo-lightbox-content')) {
            closeVimeoModal(modal);
        }
    });

    const handleEscape = function(e) {
        if (e.key === 'Escape') {
            closeVimeoModal(modal);
            document.removeEventListener('keydown', handleEscape);
        }
    };
    document.addEventListener('keydown', handleEscape);
}

function closeVimeoModal(modal) {
    modal.classList.remove('show');
    setTimeout(() => {
        modal.remove();
        document.body.style.overflow = '';
    }, 300);
}

function loadVimeoVideo(target) {
    if (!target.classList.contains('lazy')) {
        return;
    }

    const vimeoId = target.getAttribute('data-vimeo-id');
    const isModal = target.getAttribute('data-is-modal') === 'true';

    if (vimeoId) {
        let data = new FormData();
        data.append('action', 'get_vimeo_url');
        data.append('vimeo_id', vimeoId);

        $.ajax({
            url: oker_scripts.ajax_url,
            type: 'POST',
            data: data,
            cache: false,
            processData: false,
            contentType: false,
            complete: function(data) {
                try {
                    const json = JSON.parse(data.responseText);
                    if (json.url) {
                        const source = document.createElement('source');
                        source.type = 'video/mp4';
                        source.src = json.url;
                        target.appendChild(source);

                        // If this is a modal and we have dimension info, set aspect ratio
                        if (isModal && json.width && json.height) {
                            const content = target.closest('.vimeo-lightbox-content');
                            if (content) {
                                content.style.aspectRatio = `${json.width} / ${json.height}`;

                                // Check if portrait (height > width)
                                if (json.height > json.width) {
                                    content.classList.add('portrait');
                                }
                            }
                        }

                        target.onplaying = function () {
                            target.classList.add('show');
                            const loader = target.nextElementSibling;
                            if (loader) {
                                loader.style.display = 'none';
                            }
                        };

                        target.load();
                    }
                } catch (error) {
                    console.error('Error loading Vimeo video:', error);
                }
            }
        });

        target.classList.remove('lazy');
    }
}